import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../header/header';
import Footer from '../footer/footer';

const UserLayout = () => {
  return (
    <div>
      {/* User Header */}
      <Header/>

      {/* Page Content */}
      <main>
        <Outlet />
      </main>

      {/* User Footer */}
      <Footer/>
    </div>
  );
};

export default UserLayout;
